const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "black",
  d: "M12.992 21.504q1.088-1.792 6.848-9.088t6.208-7.040q0.384 0.192-3.072 8.896t-4.416 10.432q-1.6 2.752-4.352 1.152t-1.216-4.352zM16 9.344q-5.376 0-9.088 4.064t-3.712 9.952q0 0.96 0.064 1.472 0.064 0.704-0.384 1.184t-1.088 0.544-1.152-0.384-0.576-1.088q0-0.256-0.032-0.832t-0.032-0.896q0-7.232 4.64-12.224t11.36-4.992q2.304 0 4.288 0.576l-2.24 2.752q-1.28-0.128-2.048-0.128zM27.584 11.328q4.416 4.928 4.416 12.032 0 1.216-0.064 1.792-0.064 0.64-0.512 1.056t-1.088 0.416h-0.128q-0.704-0.128-1.12-0.64t-0.352-1.152q0.064-0.448 0.064-1.472 0-4.8-2.56-8.576 0.192-0.448 0.64-1.632t0.704-1.824z"
});

const SvgGauge = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    id: "icon-gauge",
    viewBox: "0 0 32 32",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGauge, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/gauge.9b736d26.svg";
export { ForwardRef as ReactComponent };